// Copyright (c) 2016 Deere & Company

import ClaimMassChannelCustomerFollowup from '@deere/cps-it.warranty-model-factory/lib/claim-mass-channel-customer-followup';

export const getUpdatedClaim = (currentClaim, selectedAction) =>
    ClaimMassChannelCustomerFollowup.update(currentClaim, {
        selectedAction: {
            $set: selectedAction
        }
    });



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/services/update-mcc-followup-claim.js